import React, { Component } from "react";
import { createRef } from "react";
import ClipLoader from "react-spinners/ClipLoader";

const WIDTH_LOCKED = "WIDTH_LOCKED";
const HEIGHT_LOCKED = "HEIGHT_LOCKED";

/**
 * TODO: Need to calculate x of crop box the same way as height
 */
class Cropper extends Component {
  state = {
    mouseDown: false,
    mouseInCanvas: false,
    boxPos: { x: 0, y: 0 },
    width: 0,
    height: 0,
    boxHeight: 0,
    boxWidth: 0,
    lockedSide: "",
    imageChanged: false,
    imageLoading: true
  };

  constructor(props) {
    super(props);
    this.onImageLoad = this.onImageLoad.bind(this);
    this.mouseDown = this.mouseDown.bind(this);
    this.mouseUp = this.mouseUp.bind(this);
    this.mouseMove = this.mouseMove.bind(this);
    this.draw = this.draw.bind(this);
    this.setCropDetails = this.setCropDetails.bind(this);
    this.setDimen = this.setDimension.bind(this);
    this.setImageChanged = this.setImageChanged.bind(this);
    this.drawAvatarCircle = this.drawAvatarCircle.bind(this);
    this.isPictureCropUnSelected = this.isPictureCropUnSelected.bind(this);

    this.canvas = createRef(null);
    this.img = createRef(null);
  }

  setImageChanged(changeTo) {
    console.log("Change Image")
    this.setState({
      imageChanged: changeTo,
      imageLoading: false
    });
  }

  componentDidMount() {
    window.addEventListener("resize", this.setDimension.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.setDimension.bind(this));
  }

  onImageLoad() {
    console.log("Image loaded")
    this.setDimension();
    this.setState({
      imageLoading: false
    });
  }

  isPictureCropUnSelected() {
    const { pictureCrop } = this.props;
    return pictureCrop.leftBottom === 0 && pictureCrop.rightTop === 0;
  }

  setDimension() {
    const { pictureCrop } = this.props;
    const { imageChanged } = this.state;

    const img = document.getElementById("band_picture");
    const container = document.getElementById("container");

    if (container && img) {
      const width = container.offsetWidth * 0.6;
      const ratio = img.height / img.width;
      const height = width * ratio;

      const smallest = Math.min(width, height);

      const lockedSide = width === smallest ? WIDTH_LOCKED : HEIGHT_LOCKED;

      const boxHeight = smallest;
      const boxWidth = smallest;

      let x;
      let y;

      if (imageChanged || this.isPictureCropUnSelected()) {
        x = width / 2;
        y = lockedSide === HEIGHT_LOCKED ? 0 : (height - boxHeight) / 2;

        this.setCropDetails({ x: x, y: y }, boxWidth, boxHeight);
        this.setImageChanged(false);
      } else {
        x = pictureCrop.leftBottom.x + boxWidth / 2;
        y = pictureCrop.leftTop.y;
      }

      const firstBoxPos = {
        x: x,
        y: y,
      };

      this.setState({
        width: width,
        height: height,
        boxHeight: boxHeight,
        boxWidth: boxWidth,
        boxPos: firstBoxPos,
        lockedSide: lockedSide,
      });

      this.setCropDetails(firstBoxPos, boxWidth, boxHeight);
    }
  }

  setCropDetails(boxPos, boxWidth, boxHeight) {
    const { changePictureCrop } = this.props;

    const left = boxPos.x - boxWidth / 2;
    const right = boxPos.x + boxWidth / 2;
    const top = boxPos.y;
    const bottom = boxPos.y + boxHeight;

    const leftTop = { x: left, y: top };
    const rightTop = { x: right, y: top };
    const rightBottom = { x: right, y: bottom };
    const leftBottom = { x: left, y: bottom };

    const cropDetails = {
      leftTop: leftTop,
      rightTop: rightTop,
      rightBottom: rightBottom,
      leftBottom: leftBottom,
    };

    changePictureCrop(cropDetails);
  }

  componentDidUpdate() {
    const { boxWidth, boxHeight } = this.state;
    this.draw(boxWidth, boxHeight);
  }

  draw(boxWidth, boxHeight) {
    const { boxPos, lockedSide } = this.state;
    const canvas = this.canvas.current;
    const img = this.img.current;

    // Don't draw if image isn't ready
    // img.complete - browser still fetching image
    // img.naturalWidth - src has failed
    if (!img || !img.complete || img.naturalWidth === 0) 
    {
      return;
    }

    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

    ctx.beginPath();
    ctx.shadowColor = "blue";
    ctx.shadowBlur = 4;
    ctx.shadowOffsetX = 3;
    ctx.shadowOffsetY = 3;
    ctx.lineWidth = "4";
    ctx.strokeStyle = "#3636F1";
    roundRect(ctx, 0, 0, canvas.width, canvas.height, 5, false, true);
    if (lockedSide === WIDTH_LOCKED) {
      this.drawHorizontalGreyedOutRect(ctx, 0, boxWidth, boxPos.y);
    } else {
      this.drawVerticalGreyedOutRect(
        ctx,
        0,
        boxHeight,
        boxPos.x - boxWidth / 2
      );
    }

    if (lockedSide === WIDTH_LOCKED) {
      const sgy = boxPos.y + boxHeight;
      this.drawHorizontalGreyedOutRect(ctx, sgy, boxWidth, canvas.height - sgy);
      this.drawAvatarCircle(
        ctx,
        boxPos.x,
        boxPos.y + boxHeight / 2,
        boxHeight / 2
      );
    } else {
      const sgx = boxPos.x + boxWidth / 2;
      this.drawVerticalGreyedOutRect(ctx, sgx, boxHeight, canvas.width - sgx);
      this.drawAvatarCircle(
        ctx,
        boxPos.x,
        boxPos.y + boxHeight / 2,
        boxWidth / 2
      );
    }

    this.drawCropRect(ctx, boxPos, boxWidth, boxHeight);
  }

  drawHorizontalGreyedOutRect(ctx, y, width, by) {
    ctx.fillStyle = `rgba(10, 10, 10, 0.23)`;
    ctx.fillRect(0, y, width, by);
  }

  drawVerticalGreyedOutRect(ctx, x, boxHeight, width) {
    ctx.fillStyle = `rgba(10, 10, 10, 0.23)`;
    ctx.fillRect(x, 0, width, boxHeight);
  }

  drawAvatarCircle(ctx, x, y, radius) {
    ctx.setLineDash([5, 3]);
    ctx.beginPath();
    ctx.arc(x, y, radius, 0, 2 * Math.PI);
    ctx.stroke();
    ctx.setLineDash([0, 0]);
  }

  drawCropRect(ctx, pos, boxWidth, boxHeight) {
    ctx.lineWidth = "4";
    roundRect(
      ctx,
      pos.x - boxWidth / 2,
      pos.y,
      boxWidth,
      boxHeight,
      5,
      false,
      true
    );
  }

  mouseUp() {
    this.setState({
      mouseDown: false,
    });
  }

  mouseDown(event) {
    this.setState({
      mouseDown: true,
    });

    this.moveMousePos(event);
  }

  mouseMove(event) {
    const { mouseDown } = this.state;

    if (mouseDown) {
      this.moveMousePos(event);
    }
  }

  moveMousePos(event) {
    const { boxWidth, boxHeight, lockedSide } = this.state;

    const canvas = this.canvas.current;

    const mousePos = getMousePos(canvas, event);

    if (lockedSide === WIDTH_LOCKED) {
      const centerY = mousePos.y - boxHeight / 2;

      mousePos.y = Math.max(0, centerY);
      mousePos.y = Math.min(canvas.height - boxHeight, mousePos.y);
      mousePos.x = boxWidth / 2;
    } else {
      mousePos.x = Math.max(boxWidth / 2, mousePos.x);
      mousePos.x = Math.min(canvas.width - boxWidth / 2, mousePos.x);
      mousePos.y = 0;
    }

    this.setState({
      boxPos: mousePos,
    });

    this.setCropDetails(mousePos, boxWidth, boxHeight);
  }

  render() {
    const { picture } = this.props;
    const { width, height, imageLoading } = this.state;

    return (
      <div>
        <ClipLoader
            color="#FFFFFF"
            sizeUnit={"%"}
            size={50}
            loading={imageLoading}
          />
        <canvas
          ref={this.canvas}
          width={width}
          height={height}
          onMouseDown={this.mouseDown}
          onMouseUp={this.mouseUp}
          onMouseMove={this.mouseMove}
        />
        <img
          id="band_picture"
          ref={this.img}
          style={{ display: "none" }}
          onLoad={this.onImageLoad}
          src={picture}
          alt="Band"
        />
      </div>
    );
  }
}

function roundRect(ctx, x, y, width, height, radius, fill, stroke) {
  if (typeof stroke === "undefined") {
    stroke = true;
  }
  if (typeof radius === "undefined") {
    radius = 5;
  }
  if (typeof radius === "number") {
    radius = { tl: radius, tr: radius, br: radius, bl: radius };
  } else {
    var defaultRadius = { tl: 0, tr: 0, br: 0, bl: 0 };
    for (var side in defaultRadius) {
      radius[side] = radius[side] || defaultRadius[side];
    }
  }
  ctx.beginPath();
  ctx.moveTo(x + radius.tl, y);
  ctx.lineTo(x + width - radius.tr, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
  ctx.lineTo(x + width, y + height - radius.br);
  ctx.quadraticCurveTo(
    x + width,
    y + height,
    x + width - radius.br,
    y + height
  );
  ctx.lineTo(x + radius.bl, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
  ctx.lineTo(x, y + radius.tl);
  ctx.quadraticCurveTo(x, y, x + radius.tl, y);
  ctx.closePath();
  if (fill) {
    ctx.fill();
  }
  if (stroke) {
    ctx.stroke();
  }
}

function getMousePos(canvas, evt) {
  var rect = canvas.getBoundingClientRect();
  return {
    x: evt.clientX - rect.left,
    y: evt.clientY - rect.top,
  };
}

export default Cropper;
